import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const MotoboyHome: React.FC = () => {
  const { userData, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold text-gray-800">Rota Entregas</h1>
            <div className="flex items-center gap-4">
              <span className="text-gray-700">Olá, {userData?.nome || 'Entregador'}</span>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Painel do Entregador</h2>
          <p className="text-gray-600">Bem-vindo ao sistema de entregas!</p>
          <p className="text-gray-500 text-sm mt-2">Esta é a versão web do sistema. Funcionalidades completas em desenvolvimento.</p>
        </div>
      </main>
    </div>
  );
};

export default MotoboyHome;

